<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>


